import { List } from "immutable";
import { createAction } from "redux-actions";
import * as AlertActions from "./NotificationActions";
import { Thunk } from "./Thunk";
import * as M from "../models";
import { Api } from "../services/Api";

const prefix = "ADMIN_EMAIL_TEMPLATE_";

export class Constants {
    public static LOADING_TEMPLATE = prefix + "LOADING_TEMPLATE";
    public static LOADING_TEMPLATES = prefix + "LOADING_TEMPLATES";
    public static LOADING_TYPES = prefix + "LOADING_TYPES";
    public static UPDATED_TEMPLATES = prefix + "UPDATED_TEMPLATES";
    public static UPDATED_TYPES = prefix + "UPDATED_TYPES";
}

interface LoadingTemplatePayload {
    id: number | string;
    loading: boolean;
}

export const loadTemplate = (id: number): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.admin.emailTemplate.template.withUrlParams({ id }));

    if (result.isSuccess && result.data)
        dispatch(updateTemplate(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingTemplate(id, false));
};

export const loadTemplates = (): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.admin.emailTemplate.templates);

    if (result.isSuccess && result.data)
        dispatch(updateTemplates(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingTemplates(false));
};

export const loadTypes = (): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.admin.emailTemplate.types);

    if (result.isSuccess && result.data)
        dispatch(updateTypes(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingTypes(false));
};

export const removeTemplate = (evt: M.Email.EmailTemplate): Thunk => async (dispatch, getState) => {
    const templates = getState().adminEmailTemplates.templates;
    const idx = templates.findIndex((x: M.Email.EmailTemplate) => x.id === evt.id);
    if (idx > -1)
        dispatch(onTemplatesUpdated(templates.remove(idx)));
};

export const updateTemplate = (item: M.Email.EmailTemplate): Thunk => async (dispatch, getState) => {
    dispatch(updateTemplates([item]));
};

export const updateTemplates = (updatedList: M.Email.EmailTemplate[]): Thunk => async (dispatch, getState) => {
    let list = getState().adminEmailTemplates.templates;
    updatedList.map((item: M.Email.EmailTemplate) => {
        const idx = list.findIndex((x: M.Email.EmailTemplate) => x.id === item.id);
        list = idx > -1
            ? list.set(idx, item)
            : list.push(item);
    });

    dispatch(onTemplatesUpdated(list));
};

export const updateTypes = (updatedList: M.Email.EmailTemplateType[]): Thunk => async (dispatch, getState) => {
    let list = getState().adminEmailTemplates.types;
    updatedList.map((item: M.Email.EmailTemplateType) => {
        const idx = list.findIndex((x: M.Email.EmailTemplateType) => x.id === item.id);
        list = idx > -1
            ? list.set(idx, item)
            : list.push(item);
    });

    dispatch(onTypesUpdated(list));
};

export const onTemplatesUpdated = createAction<List<M.Email.EmailTemplate>, List<M.Email.EmailTemplate>>(
    Constants.UPDATED_TEMPLATES, (events) => (events),
);

export const onTypesUpdated = createAction<List<M.Email.EmailTemplateType>, List<M.Email.EmailTemplateType>>(
    Constants.UPDATED_TYPES, (events) => (events),
);

export const toggleLoadingTemplate = createAction<LoadingTemplatePayload, number | string, boolean>(
    Constants.LOADING_TEMPLATE, (eventId, loading) => ({ id: eventId, loading }),
);

export const toggleLoadingTemplates = createAction<boolean, boolean>(
    Constants.LOADING_TEMPLATES, (loading) => (loading),
);

export const toggleLoadingTypes = createAction<boolean, boolean>(
    Constants.LOADING_TYPES, (loading) => (loading),
);



// WEBPACK FOOTER //
// ./src/actions/AdminEmailTemplateActions.ts